export const AD_LOCATIONS = {
    ANYWHERE_ON_PAGE: "Anywhere on results page",
    TOP_OF_PAGE: "Top of results page",
    ABSOLUTE_TOP_OF_PAGE: "Absolute top of results page",
};
